import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-modal',
  templateUrl: './privacy-policy-modal.component.html',
  styleUrls: ['./privacy-policy-modal.component.scss']
})
export class PrivacyPolicyModalComponent implements OnInit {
  @ViewChild('privacyPolicyModal') privacyPolicyTemplate!: TemplateRef<PrivacyPolicyModalComponent>;
  modalHeight: number;
  modalWidth: number;

  ngOnInit() {
    this.adjustModalHeight();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.adjustModalHeight();
  }

  adjustModalHeight() {
    this.modalHeight = window.innerHeight * 0.60;
    this.modalWidth = window.innerWidth * 0.8;
  }
}
